// extracted by mini-css-extract-plugin
export var printerCard = "_bi-1";
export var printerCardConfigured = "_bi-2";
export var printerCardError = "_bi-3";
export var printerCardsContainer = "_bi-0";
export var printerIcon = "_bi-8";
export var printerIconConfigured = "_bi-5";
export var printerIconContainer = "_bi-4";
export var printerIconError = "_bi-6";
export var printerIconUnconfigured = "_bi-7";
export var workstationsTableCard = "_bi-9";